import { DataEnvelope } from '@model/iceberg';
import { Image } from '@model/common';
import { FAQ, Link, OpeningTimes } from '@model/content/common';
import { BrandCodes } from '@model/config/brands';
import { ContentFieldTypes } from './field-types';

export enum FooterTypes {
  MAIN = 'main',
  CHECKOUT = 'checkout'
}

export interface Footer {
  fieldType: ContentFieldTypes.FOOTER;
  faqs: Array<FAQ>;
  links: Array<Link>;
  openingTimes: OpeningTimes | null;
  phoneNumber: string;
  title: string;
  travelAdvice: string;
  type: FooterTypes;
  variant: BrandCodes;
  logo: Image;
}

export type FooterModel = DataEnvelope<Footer>;
